<script setup lang="ts">
import aiCreationPreviewImage from '@/assets/images/ai-creation-preview.png';

interface ContentItem {
	header: string;
	content: string;
}

const eventCreationContentItems: ContentItem[] = [
	{
		header: 'Publish in seconds',
		content:
			'Quickly create and edit your event pages, ensuring they look just right before starting sales.',
	},
	{
		header: 'Free, Paid and Token gated ticket types',
		content: 'Offer a variety of tickets options for your events and sell as many as you’d like.',
	},
	{
		header: 'Content crafted by AI',
		content:
			'Enhance your event pages with compelling content suggestions, making your events effortlessly stand out.',
	},
];

defineProps({
	title: {
		type: String,
		default: 'Easily create events',
	},
	subTitle: {
		type: String,
		default: 'Provide a few basic details and let Peatix suggest the rest.',
	},
});
</script>

<template>
	<section class="event-preview-section">
		<div class="section-inner">
			<h2 class="title text-semibold">
				{{ title }}
			</h2>
			<p class="sub-title text-regular">
				{{ subTitle }}
			</p>
			<div class="introduction event-creation">
				<img class="preview-image" :src="aiCreationPreviewImage" alt="AI creation preview" />
				<div class="content">
					<ul class="information-list">
						<li v-for="(item, index) in eventCreationContentItems" :key="index">
							<h3 class="title text-xl text-semibold">
								{{ item.header }}
							</h3>
							<p class="sub-title text-md text-regular">
								{{ item.content }}
							</p>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</section>
</template>

<style lang="scss" scoped>
section {
	padding-top: spacings-get(12);
	text-align: center;
	background-color: colors-get(gray, 50);

	.section-inner {
		max-width: rem(1008);
		padding: 0 spacings-get(4);
		margin: 0 auto;

		> .title {
			color: colors-get(gray, 900);
			margin-bottom: spacings-get(5);
			@include fonts-size(display-md);

			@include media-query-max(mobile) {
				@include fonts-size(display-sm);
			}
		}

		> .sub-title {
			color: colors-get(gray, 600);
			margin-bottom: spacings-get(12);
			@include fonts-size(text-xl);

			@include media-query-max(mobile) {
				@include fonts-size(text-md);
			}
		}
	}

	.introduction {
		display: grid;
		grid-template-columns: 40% auto;
		padding-bottom: spacings-get(12);

		@include media-query-max(mobile) {
			grid-template-columns: 1fr;
		}

		&.event-creation {
			gap: rem(72);

			@include media-query-max(mobile) {
				gap: spacings-get(10);
			}
		}

		.preview-image {
			width: 100%;
		}

		.content {
			text-align: start;
			margin: auto;
		}
	}

	.information-list {
		.title {
			color: colors-get(gray, 900);
		}

		.sub-title {
			color: colors-get(gray, 600);
		}
	}
}
</style>
